export default {
  TIFF_TYPES: ['tiff', 'tif'],
};
